/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingInformationBase {
    type: string;

    protected setDiscriminator(type: string) {
        this.type = type;
    }

    getFixupPrototypeFunction() { return BillingInformationBase.fixupPrototype; }

    static newInstance(model: Partial<BillingInformationBase>): BillingInformationBase {
        let obj = Object.assign(new BillingInformationBase(), model);
        BillingInformationBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingInformationBase>): BillingInformationBase {
        if (!model) return null;
        return BillingInformationBase.newInstance(<BillingInformationBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingInformationBase) {
        if (!obj) return;

        models.BillingInformationBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingInformationBase): boolean {
        switch (obj.type)
        {
            case "BillingInformationDetailForAws":
                Object.setPrototypeOf(obj, models.BillingInformationDetailForAws.prototype);
                break;
            case "BillingInformationDetailForAzureCsp":
                Object.setPrototypeOf(obj, models.BillingInformationDetailForAzureCsp.prototype);
                break;
            case "BillingInformationDetailForAzureEa":
                Object.setPrototypeOf(obj, models.BillingInformationDetailForAzureEa.prototype);
                break;
            case "BillingInformationDetailForAzureMca":
                Object.setPrototypeOf(obj, models.BillingInformationDetailForAzureMca.prototype);
                break;
            case "BillingInformationDetailForAzureSubscription":
                Object.setPrototypeOf(obj, models.BillingInformationDetailForAzureSubscription.prototype);
                break;
            case "BillingInformationDetailForSaas":
                Object.setPrototypeOf(obj, models.BillingInformationDetailForSaas.prototype);
                break;
        }
        return true; // Tell the caller this is a polymorphic type, it should not overwrite the prototype.
    }

    static getTypeHierarchy(): (typeof BillingInformationBase)[] {
        return [
            models.BillingInformationDetailForAws,
            models.BillingInformationDetailForAzureCsp,
            models.BillingInformationDetailForAzureEa,
            models.BillingInformationDetailForAzureMca,
            models.BillingInformationDetailForAzureSubscription,
            models.BillingInformationDetailForSaas,
        ];
    }

    fixupFields() {
    }

}
